/* Algolia header autocomplete (v1) - L'Oiseau de Paradis
   Spec: docs/superpowers/specs/2026-06-06-algolia-header-autocomplete-design.md
   Isolation stricte: lit window.algoliaShopify.searchClient/config ; ne touche jamais au pipeline InstantSearch
   ni a la config Algolia globale (lecon de l'incident wf du 2026-06-06). */

/* Namespace partage par les deux IIFE de ce fichier + expose les helpers purs pour test navigateur
   (le repo n'a pas de harnais unitaire). Lecture seule, aucune mutation de la config/pipeline Algolia. */
window.__ldpAlgolia = window.__ldpAlgolia || (function () {
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function currentLocale() { var m = root().match(/^\/([a-z]{2})\//i); return m ? m[1].toLowerCase() : 'fr'; }
  // Index produits de la locale courante (FR -> shopify_products, EN -> shopify_products_france_en).
  // NB: copie volontaire de la logique de la 1re IIFE (productsIndex) - on ne modifie pas le code
  // autocomplete deja en prod ; les 2 copies derivent de la meme config.
  function productsIndex() {
    var a = window.algoliaShopify || {}, c = a.config || {};
    var prefix = c.index_prefix || 'shopify_';
    var loc = currentLocale();
    var marketId = a.shopify && a.shopify.market && a.shopify.market.id;
    var mm = (c.markets_mapping || []).filter(function (x) {
      return String(x.id) === String(marketId) && x.locale === loc;
    })[0];
    var suffix = mm ? mm.suffix : (loc === 'fr' ? '' : 'france_' + loc);
    return prefix + 'products' + (suffix ? '_' + suffix : '');
  }
  // Vraie remise : compare-at strictement > prix ET > 0 (jamais price_ratio < 1 : il vaut 0 pour compare-at nul).
  function isDiscount(price, compareAt) {
    var p = parseFloat(price), c = parseFloat(compareAt);
    return isFinite(p) && isFinite(c) && c > 0 && c > p;
  }
  // Formate `value` (nombre) selon le format d'un prix deja rendu (`sample`, ex "€95.00") :
  // recopie prefixe/suffixe non numeriques + separateur decimal + nb de decimales. Pas de separateur de milliers.
  function formatLikePrice(sample, value) {
    sample = String(sample == null ? '' : sample);
    var m = sample.match(/[0-9][0-9.,\s ]*[0-9]|[0-9]/);
    if (!m) return String(value);
    var numStr = m[0];
    var prefix = sample.slice(0, m.index);
    var suffix = sample.slice(m.index + numStr.length);
    var dm = numStr.match(/([.,])(\d{1,2})$/);
    var decSep = dm ? dm[1] : '.';
    var decimals = dm ? dm[2].length : 0;
    var out = Number(value).toFixed(decimals);
    if (decSep !== '.') out = out.replace('.', decSep);
    return prefix + out + suffix;
  }
  return { root: root, currentLocale: currentLocale, productsIndex: productsIndex, isDiscount: isDiscount, formatLikePrice: formatLikePrice };
})();

(function () {
  if (window.__algoliaHeaderAC) return;
  window.__algoliaHeaderAC = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function currentLocale() {
    var m = ROOT.match(/^\/([a-z]{2})\//i);
    return m ? m[1].toLowerCase() : 'fr';
  }
  function productsIndex() {
    var a = window.algoliaShopify || {}, c = a.config || {};
    var prefix = c.index_prefix || 'shopify_';
    var loc = currentLocale();
    var marketId = a.shopify && a.shopify.market && a.shopify.market.id;
    var mm = (c.markets_mapping || []).filter(function (x) {
      return String(x.id) === String(marketId) && x.locale === loc;
    })[0];
    var suffix = mm ? mm.suffix : (loc === 'fr' ? '' : 'france_' + loc);
    return prefix + 'products' + (suffix ? '_' + suffix : '');
  }
  function imgOf(it) {
    return (it.image && (it.image.src || it.image)) || it.product_image ||
      (it.images && it.images[0] && (it.images[0].src || it.images[0])) || '';
  }
  function fmtEuro(n) { return '€' + Number(n).toFixed(2); }
  // Noeud prix de l'item autocomplete : barre + rouge si remise, sinon prix unique (toujours 2 decimales).
  function priceNode(html, it) {
    var NS = window.__ldpAlgolia;
    if (NS && NS.isDiscount(it.price, it.compare_at_price)) {
      return html`<span class="algolia-ac-item__price"><span class="ldp-compare-at">${fmtEuro(it.compare_at_price)}</span><span class="ldp-sale-price">${fmtEuro(it.price)}</span></span>`;
    }
    return html`<span class="algolia-ac-item__price">${it.price != null ? fmtEuro(it.price) : ''}</span>`;
  }

  var STR = {
    fr: { seeAll: 'Afficher tous les résultats', noResults: 'Aucun résultat' },
    en: { seeAll: 'Show all results', noResults: 'No results' }
  };
  function t(key) { return (STR[currentLocale()] || STR.fr)[key]; }

  function mountOn(input, lib, sc) {
    if (input.__acMounted) return;
    input.__acMounted = true;
    var autocomplete = lib.autocomplete, getAlgoliaResults = lib.getAlgoliaResults;
    var INDEX = productsIndex();
    var container = document.createElement('div');
    container.className = 'algolia-ac-container';
    input.parentNode.insertBefore(container, input);
    input.style.display = 'none';

    autocomplete({
      container: container,
      placeholder: input.getAttribute('placeholder') || 'Rechercher',
      openOnFocus: false,
      detachedMediaQuery: 'none',
      onSubmit: function (p) {
        var q = (p.state && p.state.query) || '';
        if (q) window.location.href = ROOT + 'search?q=' + encodeURIComponent(q);
      },
      onStateChange: function (p) {
        // Sync vers l'input natif masque pour que la loupe du theme / submit natif portent la requete.
        try { input.value = (p.state && p.state.query) || ''; } catch (e) {}
      },
      getSources: function (ctx) {
        var query = ctx.query;
        if (!query) return [];
        return [
          {
            sourceId: 'products',
            getItemUrl: function (p) { return ROOT + 'products/' + p.item.handle; },
            getItems: function () {
              return getAlgoliaResults({
                searchClient: sc,
                queries: [{ indexName: INDEX, query: query, params: { hitsPerPage: 5 } }],
              });
            },
            templates: {
              item: function (p) {
                var it = p.item, html = p.html;
                return html`<a class="algolia-ac-item" href=${ROOT + 'products/' + it.handle}>
                  <img class="algolia-ac-item__img" src=${imgOf(it)} alt="" loading="lazy" />
                  <span class="algolia-ac-item__body">
                    <span class="algolia-ac-item__title">${it.title}</span>
                    ${priceNode(html, it)}
                  </span>
                </a>`;
              },
              noResults: function (p) {
                return p.html`<div class="algolia-ac-empty">${t('noResults')}</div>`;
              },
            },
          },
          {
            sourceId: 'seeAll',
            getItems: function () { return query ? [{ label: query }] : []; },
            templates: {
              item: function (p) {
                var url = ROOT + 'search?q=' + encodeURIComponent(p.item.label);
                return p.html`<a class="algolia-ac-seeall" href=${url}>${t('seeAll')}</a>`;
              },
            },
          },
        ];
      },
    });
  }

  function suppressNativePredictive() {
    // Provisoire (Task 6 affinera): masque le menu predictive natif du theme.
    document.querySelectorAll('.search-results__results').forEach(function (el) {
      el.style.display = 'none';
      el.setAttribute('data-algolia-suppressed', '1');
    });
  }

  function boot() {
    var lib = window['@algolia/autocomplete-js'];
    var a = window.algoliaShopify || {};
    var sc = a.searchClient;
    if (!lib || !lib.autocomplete || !sc) return false;
    var inputs = document.querySelectorAll('input[name="q"].search-form__input');
    if (!inputs.length) return false;
    inputs.forEach(function (inp) { mountOn(inp, lib, sc); });
    suppressNativePredictive();
    console.log('[algolia-ac] mounted ' + inputs.length + ' input(s), index=' + productsIndex());
    return true;
  }

  // Attend la lib (CDN), algoliaShopify et les inputs.
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (boot() || tries > 200) clearInterval(iv);
  }, 50);
})();

/* Personnalisations des pages de resultats (recherche / collections) :
   1) Images en plus haute definition : l'app sert les images en 250px ; affichees ~240px elles
      paraissent floues (surtout retina). On remplace le token Shopify (_250x.) par _600x. et on
      retire le srcset (densites 1x/2x/3x prevues pour 125px) pour forcer la source nette.
   2) Placeholder de la barre de recherche en FR : l'app le rend en "Search for products" meme en
      FR (translations.searchForProduct mal localise) ; on force "Rechercher dans la boutique".
   3) Libelles FR non traduits par l'app : certains `translations.*` restent en anglais. On traduit
      en DOM le widget Stats ("out of"/"results found"/"in") et le tri ("Sorted by", "Relevance",
      "Highest discount first"). FR uniquement ; l'EN garde l'anglais d'origine. On agit au niveau
      des noeuds texte (les nombres page/total/duree sont dynamiques) -> remplacement idempotent.
   MutationObserver pour re-appliquer apres chaque re-rendu (filtres, pagination). */
(function () {
  function isFr() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var m = root.match(/^\/([a-z]{2})\//i);
    return (m ? m[1].toLowerCase() : 'fr') === 'fr';
  }
  function upgrade(img) {
    if (img.__hd) return;
    var src = img.getAttribute('src') || '';
    var n = src.replace(/_(\d+)x(\.[a-z]+)(\?|$)/i, '_600x$2$3');
    if (n !== src) { img.__hd = 1; img.removeAttribute('srcset'); img.setAttribute('src', n); }
  }
  function fixPlaceholder() {
    if (!isFr()) return;
    var inputs = document.querySelectorAll('.ais-input input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('placeholder') !== 'Rechercher dans la boutique') {
        inputs[i].setAttribute('placeholder', 'Rechercher dans la boutique');
      }
    }
  }
  // Remplace des mots dans les noeuds texte sous `root`. Idempotent (ne reecrit que si ca change),
  // donc sans risque de boucle avec le MutationObserver (childList) ni avec le re-rendu de l'app.
  function translateTextNodes(root, reps) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].nodeValue, nv = v;
      for (var j = 0; j < reps.length; j++) nv = nv.replace(reps[j][0], reps[j][1]);
      if (nv !== v) nodes[i].nodeValue = nv;
    }
  }
  // Stats : "1 - 24 out of 354 results found in 0.001s" -> "1 - 24 sur 354 resultats trouves en 0.001s".
  function translateStatsFr() {
    translateTextNodes(document.querySelector('.ais-Stats'), [
      [/\bout of\b/g, 'sur'],
      [/\bresults found\b/g, 'résultats trouvés'],
      [/\bresult found\b/g, 'résultat trouvé'],
      [/\bin\b/g, 'en'],
    ]);
  }
  // Tri : libelle "Sorted by" + options restees en anglais ("Relevance", "Highest discount first").
  function translateSortFr() {
    translateTextNodes(document.querySelector('.ais-sort'), [
      [/Sorted by/g, 'Trié par'],
      [/Relevance/g, 'Pertinence'],
      [/Highest discount first/g, 'Les meilleures remises'],
    ]);
  }
  // ---- Remises : ancien prix barre + prix reduit rouge sur les cartes .ais-hit ----
  // Lecture seule : on resout compare_at_price par objectID via searchClient.search (filters objectID),
  // avec cache de session. Aucune mutation du pipeline/config Algolia.
  var priceCache = {}; // objectID -> {price, compare_at_price} | null (null = pas de remise/inconnu)
  var pricePending = {}; // objectID -> 1 (requete en vol, evite les doublons)

  function applyDiscount(hit) {
    if (hit.__ldpDiscount) return;
    var oid = hit.getAttribute('data-algolia-objectid');
    if (oid && !Object.prototype.hasOwnProperty.call(priceCache, oid)) return; // pas encore recupere
    var rec = oid ? priceCache[oid] : null;
    var priceEl = hit.querySelector('.ais-hit--price');
    if (!priceEl) { hit.__ldpDiscount = 1; return; }
    var NS = window.__ldpAlgolia;
    if (rec && NS && NS.isDiscount(rec.price, rec.compare_at_price)) {
      var sample = priceEl.textContent.trim();                 // ex "€95.00" (prix reduit deja affiche)
      var compareStr = NS.formatLikePrice(sample, rec.compare_at_price);
      priceEl.innerHTML = '<span class="ldp-compare-at"></span><b class="ldp-sale-price"></b>';
      priceEl.querySelector('.ldp-compare-at').textContent = compareStr;
      priceEl.querySelector('.ldp-sale-price').textContent = sample;
    }
    hit.__ldpDiscount = 1;
  }

  function fetchPrices(ids) {
    var sc = (window.algoliaShopify || {}).searchClient, NS = window.__ldpAlgolia;
    if (!sc || !NS) { for (var z = 0; z < ids.length; z++) { priceCache[ids[z]] = null; delete pricePending[ids[z]]; } return; }
    var filters = ids.map(function (id) { return 'objectID:' + id; }).join(' OR ');
    // Forme "v4" (tableau nu, parametres sous `params`) volontairement conservee sur le client v5 :
    // celui-ci la normalise lui-meme (Array.isArray -> {requests}, puis aplatissement de `params`),
    // c'est sa couche de compatibilite, non documentee mais verifiee dans sa source le 2026-08-04.
    // C'est aussi la forme qu'emet @algolia/autocomplete-js, y compris en derniere version.
    sc.search([{ indexName: NS.productsIndex(), params: {
      filters: filters, hitsPerPage: ids.length,
      attributesToRetrieve: ['objectID', 'price', 'compare_at_price'],
      attributesToHighlight: [], attributesToSnippet: []
    } }]).then(function (res) {
      var r = (res.results && res.results[0]) || res, hits = (r && r.hits) || [], seen = {};
      for (var i = 0; i < hits.length; i++) { priceCache[hits[i].objectID] = { price: hits[i].price, compare_at_price: hits[i].compare_at_price }; seen[hits[i].objectID] = 1; }
      for (var j = 0; j < ids.length; j++) { if (!seen[ids[j]]) priceCache[ids[j]] = null; delete pricePending[ids[j]]; }
      schedule(); // re-balayage pour appliquer
    }).catch(function () {
      for (var k = 0; k < ids.length; k++) { priceCache[ids[k]] = null; delete pricePending[ids[k]]; }
    });
  }

  function decorateDiscounts() {
    var hits = document.querySelectorAll('.ais-hit[data-algolia-objectid]');
    var toFetch = [];
    for (var i = 0; i < hits.length; i++) {
      var hit = hits[i];
      if (hit.__ldpDiscount) continue;
      var oid = hit.getAttribute('data-algolia-objectid');
      if (!oid) { hit.__ldpDiscount = 1; continue; }
      if (Object.prototype.hasOwnProperty.call(priceCache, oid)) { applyDiscount(hit); }
      else if (!pricePending[oid] && toFetch.indexOf(oid) === -1) { toFetch.push(oid); }
    }
    if (toFetch.length) { for (var k = 0; k < toFetch.length; k++) pricePending[toFetch[k]] = 1; fetchPrices(toFetch); }
  }
  function sweep() {
    var imgs = document.querySelectorAll('.ais-hit--picture');
    for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
    fixPlaceholder();
    if (isFr()) { translateStatsFr(); translateSortFr(); }
    decorateDiscounts();
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () { scheduled = false; sweep(); });
  }
  function start() {
    sweep();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* Traduction du bouton de filtres de l'app ("Show filters" / "Hide filters" est code en dur
   dans le widget InstantSearch de l'app, alors que le reste de son UI est localise).
   Reecriture DOM-only sous observer, comme les blocs precedents : l'app reecrit le libelle
   a chaque bascule du panneau, on retraduit derriere elle. Converge sans boucle : un libelle
   deja traduit n'est plus dans la table de correspondance, donc plus aucune reecriture. */
(function () {
  var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var LABELS = {
    fr: { 'Show filters': 'Afficher les filtres', 'Hide filters': 'Masquer les filtres' },
    es: { 'Show filters': 'Mostrar filtros', 'Hide filters': 'Ocultar filtros' },
    de: { 'Show filters': 'Filter anzeigen', 'Hide filters': 'Filter ausblenden' }
  };
  var map = LABELS[lang];
  if (!map) return; /* en et locales inconnues : libelle d'origine du widget */
  function translate() {
    var els = document.querySelectorAll('.ais-facets-button');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').trim();
      if (map[t]) els[i].textContent = map[t];
    }
  }
  function start() {
    translate();
    try {
      new MutationObserver(translate).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
